import { render, staticRenderFns } from "./ChatMessageActions.vue?vue&type=template&id=6d1d9820&scoped=true"
import script from "./ChatMessageActions.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessageActions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatMessageActions.vue?vue&type=style&index=0&id=6d1d9820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1d9820",
  null
  
)

export default component.exports